"use client";

import "./fileUploadPage.css";
import FileUploadPageLogic from "./fileUploadPageLogic";
import { MdFolder } from "react-icons/md";
import { MdCancel } from "react-icons/md";

const FileUploadPage = () => {

    const {
        datasets,
        isModalOpen,
        selectedDataset,
        vinId,
        notes,
        files,
        errors,
        fileInputKey,
        dragOverIndex,
        handleOpenModal,
        handleCloseModal,
        handleVinIdChange,
        handleVinIdBlur,
        handleNotesChange,
        handleFileChange,
        removeFile,
        handleUpload,
        handleDragOver,
        handleDragLeave,
        handleDropOnFolder
    } = FileUploadPageLogic();

    return (

        <div className="file-upload-page-container">
            <div className="file-upload-header-card">
                <span className="file-upload-page-title">
                    Files Upload
                </span>
            </div>

            <div className="folder-main-wrapper">
                {
                    datasets.map((dataset, index) => (
                        <div
                            key={index}
                            className={`folder-card ${dragOverIndex === index ? "drag-over" : ""}`}
                            onClick={() => handleOpenModal(dataset)}
                            onDragOver={(e) => handleDragOver(e, index)}
                            onDragLeave={handleDragLeave}
                            onDrop={(e) => handleDropOnFolder(e, dataset)}
                        >
                            <MdFolder size={120} style={{ color: "var(--buttonColor)" }} />

                            <span className="folder-label">
                                {dataset.datasetName}
                            </span>

                        </div>
                    ))
                }
            </div>

            {
                isModalOpen &&
                <div className="upload-modal-overlay">
                    <div className="upload-modal-container">
                        <div className="upload-modal-header">
                            <span>
                                {selectedDataset?.datasetName}
                            </span>
                            <button
                                className="modal-close-btn"
                                onClick={handleCloseModal}
                            >
                                <MdCancel size={22} />
                            </button>

                        </div>

                        <div className="upload-modal-body">

                            {/* VIN ID */}
                            <div className="upload-row">
                                <label>Vin Id <span style={{ color: "#dc3545" }}>*</span></label>
                                <div className="upload-field-container">
                                    <input
                                        type="text"
                                        className={`form-control ${errors.vinId ? "is-invalid" : ""}`}
                                        placeholder="Enter Vin Id"
                                        value={vinId}
                                        onChange={handleVinIdChange}
                                        onBlur={handleVinIdBlur}
                                    />

                                    {
                                        errors.vinId && (
                                            <div className="error-text-Dataset">
                                                {errors.vinId}
                                            </div>
                                        )
                                    }

                                </div>
                            </div>

                            {/* NOTES */}
                            <div className="upload-row">
                                <label>Notes <span style={{ color: "#dc3545" }}>*</span></label>
                                <div className="upload-field-container">
                                    <textarea
                                        placeholder="Enter Notes"
                                        className={`form-control ${errors.notes ? "is-invalid" : ""}`}
                                        value={notes}
                                        onChange={handleNotesChange}
                                    />

                                    {
                                        errors.notes && (
                                            <div className="error-text-Dataset">
                                                {errors.notes}
                                            </div>
                                        )
                                    }

                                </div>
                            </div>

                            {/* FILES */}
                            <div className="upload-row">
                                <label>Choose Files <span style={{ color: "#dc3545" }}>*</span></label>
                                <div className="upload-field-container">
                                    <div className="choose-file-box">
                                        <input
                                            key={fileInputKey}
                                            type="file"
                                            accept="application/pdf"
                                            className={`form-control ${errors.files ? "is-invalid" : ""}`}
                                            multiple
                                            onChange={handleFileChange}
                                        />

                                        <div className="drag-drop-text">
                                            Drag and drop files here or click to browse
                                        </div>
                                    </div>

                                    {
                                        errors.files && (
                                            <div className="error-text-Dataset">
                                                {errors.files}
                                            </div>
                                        )
                                    }

                                </div>
                            </div>

                            {/* FILE DETAILS */}
                            <div className="upload-row">
                                <label>
                                    File Details
                                </label>
                                <div className="upload-field-container">
                                    <div className="file-details-box">
                                        {
                                            files.length === 0 ? (

                                                <div className="no-files-text">
                                                    No Selected Files
                                                </div>

                                            ) : (

                                                files.map((file, index) => (
                                                    <div
                                                        className="file-detail-item"
                                                        key={index}
                                                    >
                                                        <div className="file-name-section">
                                                            <span className="file-number">
                                                                {index + 1}.
                                                            </span>
                                                            <span className="file-name">
                                                                {file.originalName || file.name}
                                                            </span>
                                                            <span className="file-size" style={{ color: "#999", fontStyle: "italic" }}>
                                                                → {file.name}
                                                            </span>
                                                            <span className="file-size">
                                                                ({(file.size / 1024 / 1024).toFixed(2)} MB)
                                                            </span>
                                                        </div>
                                                        <button
                                                            className="remove-file-btn"
                                                            onClick={() => removeFile(index)}
                                                        >
                                                            <MdCancel size={18} />
                                                        </button>
                                                    </div>
                                                ))
                                            )
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className="upload-footer">
                                <button
                                    className="upload-submit-btn"
                                    onClick={handleUpload}
                                >
                                    Upload
                                </button>
                            </div>

                        </div>

                    </div>

                </div>
            }

        </div>
    );
};

export default FileUploadPage;